import type { BillingNoteTemplate } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

export async function fetchBillingNoteTemplates(): Promise<
  BillingNoteTemplate[]
> {
  const response = await Client.get<BillingNoteTemplate[]>({
    endpoint: '/billing/note-templates',
  });
  return response.data;
}
